export default __webpack_public_path__ + "static/documents-system-1-80d61ec77b8e55ce5a6aac845f6cab9f.png";